/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectTimesUpdateQuery } from '../../models/get-project-times-update-query';
import { GetProjectTimesUpdateQueryResult } from '../../models/get-project-times-update-query-result';

export interface ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Params {
  
    /**
     * [Id for project]
     */
    body?: GetProjectTimesUpdateQuery
}

export function apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectTimesUpdateQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectTimesUpdateQueryResult>;
    })
  );
}

apiProjectTimeUpdateGetAllProjectTimeUpdatesPost$Plain.PATH = '/api/ProjectTimeUpdate/GetAllProjectTimeUpdates';
